/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.ReferredTitle,
        questionText: "Title",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredFirstName,
        questionText: "First Name",
        canBeDisabled: false
    },
    {
        id: questionIds.ReferredLastName,
        questionText: "Last Name",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employment Reference Number",
        canBeDisabled: false
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Title",
        canBeDisabled: false
    },
    {
        id: questionIds.DepartmentId,
        questionText: "Department",
        canBeDisabled: false
    },
    {
        id: questionIds.PersonalEmailAddress,
        questionText: "Email Address",
        canBeDisabled: false
    },
    {
        id: questionIds.EmailAddressConfirmed,
        questionText: "Confirm Email Address",
        canBeDisabled: false
    },
    {
        id: questionIds.IndividualAwareAccessPrivacyStatementConsent,
        questionText: "I can confirm that I have made the individual I am inviting to complete this risk assessment aware that I am providing Optima Health with their personal information listed ABOVE",
        canBeDisabled: false
    },
    {
        id: questionIds.IndividualAwareOfInviteConsent,
        questionText: "I have provided the individual above with access to the Optima Health Privacy Statement which clearly explains how, where and when their personal information and health data will be processed",
        canBeDisabled: false
    },
    {
        id: questionIds.IndividualAwareRequestAccessInWritingConsent,
        questionText: "I understand that all the information about the individual that is collected during the risk assessment process will be held securely and if the individual wishes to gain access to any information that Optima Health hold about them they can do so by requesting",
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
